import { FilterTemplatesGridView } from '~/components/catalog/filter-templates/grid';
import { PageContainer } from '~/components/page-container';

export function FilterTemplates() {
	return (
		<PageContainer>
			<FilterTemplatesGridView />
		</PageContainer>
	);
}
